module.exports = __webpack_public_path__ + "static/media/commercial-icon.4289b9af.svg";